const normalize = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[’']/g, ' ')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

export function isTaskNavigationVoiceCommand(value) {
  const text = normalize(value);
  if (!/\b(ouvre|ouvrir|affiche|afficher|montre|montrer|passe|passer|va|aller)\b/.test(text)) return false;
  if (/\b(suivante?|prochaine?|precedente?)\b/.test(text)) return true;
  return /\b(user story|us|numero|premiere?|deuxieme|seconde?|troisieme|quatrieme|cinquieme|sixieme|septieme|huitieme|neuvieme|dixieme|derniere?)\b/.test(text)
    || /\b(?:ouvre|affiche|montre)\s+(?:la\s+|le\s+)?(?:ans[- ]?)?\d+\b/.test(text);
}

export function isCorrectionVoiceCommand(value) {
  const text=normalize(value);
  return /\b(?:demande|demander|envoie|envoyer|souhaite|veux|voudrais|aimerais|ouvre|ouvrir)\b.*\b(?:correction|modification)\b/.test(text)
    || /\b(?:corrige|corriger|modifie|modifier)\b.*\b(?:us|user story|fiche)\b/.test(text);
}

export function isCorrectionConfirmation(value) {
  const text=normalize(value).replace(/^(?:dynamics|dynamix|dynamic|dynamique)[, ]+/, '').replace(/[.!?,]+/g,'').trim();
  return /^(?:oui(?: je confirme)?|ok|d accord|je confirme|confirme|confirmer|envoie|envoyer|valide|valider)(?:\s+(?:l envoi|la demande|la correction|les modifications?))?$/.test(text);
}

export const isDashboardVoiceCommand = value => isTaskNavigationVoiceCommand(value) || isCorrectionVoiceCommand(value) || isCorrectionConfirmation(value);
